(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["elemental-lifestyle-video"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('elemental-lifestyle-video')){
customElements.define('elemental-lifestyle-video',class extends HTMLElement{
connectedCallback(){
if(this.abort)return;
this.abort=new AbortController();const signal=this.abort.signal;
this.video=this.querySelector('video');this.button=this.querySelector('button');this.visible=false;this.userPaused=false;this.pending=false;this.blocked=false;
const v=this.video,b=this.button;if(!v||!b)return;
v.autoplay=false;v.muted=false;v.loop=true;v.playsInline=true;
this.motion=matchMedia('(prefers-reduced-motion: reduce)');
const label=()=>{b.textContent=v.paused?this.dataset.play:this.dataset.pause;};
v.addEventListener('play',()=>{label();document.querySelectorAll('video').forEach(other=>{if(other!==v&&!other.paused)other.pause();});},{signal});
v.addEventListener('pause',()=>{if(this.visible&&!document.hidden)this.userPaused=true;label();},{signal});
b.addEventListener('click',()=>{if(!v.paused){this.userPaused=true;v.pause();}else{this.userPaused=false;this.blocked=false;v.muted=false;this.start(true);}},{signal});
this.observer=new IntersectionObserver(entries=>{for(const e of entries){this.visible=e.isIntersecting&&e.intersectionRatio>=0.35;if(this.visible)this.start(false);else v.pause();}},{threshold:[0,0.35]});this.observer.observe(this);
document.addEventListener('visibilitychange',()=>{if(document.hidden)v.pause();else if(this.visible)this.start(false);},{signal});
this.motion.addEventListener('change',()=>{if(this.motion.matches)v.pause();},{signal});label();
}
start(manual){
const v=this.video;if(this.pending||!v.paused||(!manual&&(this.userPaused||this.blocked||this.motion.matches||document.hidden)))return;
this.pending=true;v.play().then(()=>{if(!this.visible||document.hidden)v.pause();}).catch(()=>{this.blocked=true;this.button.textContent=this.dataset.play;}).finally(()=>{this.pending=false;});
}
disconnectedCallback(){this.visible=false;this.video?.pause();this.observer?.disconnect();this.abort?.abort();this.abort=null;}
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["elemental-preview-playback"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('elemental-preview-playback')){
customElements.define('elemental-preview-playback',class extends HTMLElement{
connectedCallback(){
if(this.abort)return;this.abort=new AbortController();const signal=this.abort.signal;
this.root=this.closest('.efocus__quick');this.videos=Array.from(this.root.querySelectorAll('.elemental-quick-preview'));this.visible=new Set();this.busy=new Set();this.button=this.querySelector('button');this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.stopped=this.motion.matches;
this.refreshLabel=()=>{this.button.textContent=this.stopped?this.dataset.play:this.dataset.pause;this.button.setAttribute('aria-pressed',String(this.stopped));};
this.button.addEventListener('click',()=>{this.stopped=!this.stopped;this.refreshLabel();this.sync();},{signal});
this.observer=new IntersectionObserver(entries=>{for(const e of entries){if(e.isIntersecting&&e.intersectionRatio>=0.6)this.visible.add(e.target);else this.visible.delete(e.target);}this.sync();},{threshold:[0,0.6]});
this.videos.forEach(v=>{v.muted=true;v.loop=true;v.playsInline=true;this.observer.observe(v);});
document.addEventListener('play',e=>{if(e.target instanceof HTMLVideoElement&&!e.target.classList.contains('elemental-quick-preview'))this.videos.forEach(v=>v.pause());},{capture:true,signal});
document.addEventListener('visibilitychange',()=>this.sync(),{signal});
this.motion.addEventListener('change',()=>{this.stopped=this.motion.matches;this.refreshLabel();this.sync();},{signal});this.refreshLabel();
}
sync(){
const otherPlaying=Array.from(document.querySelectorAll('video')).some(v=>!v.classList.contains('elemental-quick-preview')&&!v.paused);
this.videos.forEach(v=>{const allowed=!this.stopped&&!document.hidden&&!otherPlaying&&this.visible.has(v);
if(!allowed){v.pause();return;}if(v.paused&&!this.busy.has(v)){this.busy.add(v);v.play().then(()=>{if(this.stopped||document.hidden||!this.visible.has(v))v.pause();}).catch(()=>{}).finally(()=>this.busy.delete(v));}});
}
disconnectedCallback(){this.stopped=true;this.videos?.forEach(v=>v.pause());this.observer?.disconnect();this.abort?.abort();this.abort=null;}
});
}
  } catch(e) { console.error(e); }
})();

})();
